import React from 'react'
import { PopupMessageModal } from '../../../shared/webcomponents/react-wrappers/PopupMessageModal'
import { ReAuthConfirmationModal } from '../../../app-core/lib/ui/ReAuthConfirmationModal'
import { Translations } from '../../../shared/i18n/Translations'

export enum Flow_ReAuthModalType {
    OfflineError,
    Confirmation,
    UnexpectedError,
}

interface Props {
    visibleReAuthModal: Flow_ReAuthModalType
    onCancel: () => void
    navigateToReportSigning: () => Promise<void>
    unexpectedErrorMessage: string
    confirmationMessage: string
    offlineMessage: string
}

export function Flow_ReauthModals(props: Props) {
    return (
        <>
            {OfflineErrorModal()}
            {ConfirmationModal()}
            {UnexpectedErrorModal()}
        </>
    )

    function OfflineErrorModal() {
        return (
            <PopupMessageModal
                isOpen={props.visibleReAuthModal === Flow_ReAuthModalType.OfflineError}
                heading={Translations.t('appcore:noInternet.title')}
                message={props.offlineMessage}
                iconName="cloud-cross"
                cancelLabel={Translations.t('appcore:FileGuideErrorModal.goBack')}
                submitLabel={Translations.t('appcore:common.tryAgain')}
                onCancel={props.onCancel}
                onSubmit={props.navigateToReportSigning}
            />
        )
    }

    function ConfirmationModal() {
        return (
            <ReAuthConfirmationModal
                isOpen={props.visibleReAuthModal === Flow_ReAuthModalType.Confirmation}
                message={props.confirmationMessage}
                onSubmit={props.navigateToReportSigning}
                onCancel={props.onCancel}
            />
        )
    }

    function UnexpectedErrorModal() {
        return (
            <PopupMessageModal
                isOpen={props.visibleReAuthModal === Flow_ReAuthModalType.UnexpectedError}
                heading={Translations.t('appcore:common.errorOccurred')}
                message={props.unexpectedErrorMessage}
                iconName="spilled-coffee-cup"
                cancelLabel={Translations.t('appcore:common.close')}
                canSubmit={false}
                onCancel={props.onCancel}
            />
        )
    }
}
